// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__lA+qD","nav_items":"header_nav_items__kybNe"};